import { subtractDay } from 'components/DatePicker/constants';

export function calAdperformanceRange (startDate) {
  return {
    1: {
      label: "30 Days",
      value: 1,
      start: subtractDay(30, startDate),
      end: subtractDay(1, startDate)
    },
    2: {
      label: "60 Days",
      value: 2,
      start: subtractDay(60, startDate),
      end: subtractDay(1, startDate)
    }
  }
}

export const defaultAdperformanceRangeValue = 1;
